module.exports = __webpack_public_path__ + "static/media/screen.73aa334a.svg";